import { action, computed, observable, makeObservable } from 'mobx';
import {SuccessResponse, TimeZone, timeZoneLoaders, TimeZoneUpdateModel} from '../../../domain';
import {HttpPromiseState, StringControl, toInt, validators} from '../../../lib/helpers';

export class EditTimeZoneStore {
  readonly name: StringControl;
  readonly utcOffset: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly timeZone: TimeZone) {
    makeObservable(this);
    this.name = new StringControl('', '', validators.required);
    this.utcOffset = new StringControl('', '',
      [validators.required, validators.intString(-14 * 60, 14 * 60)]);
    this.name.setValue(timeZone.Name);
    this.utcOffset.setValue(timeZone.UtcOffsetMinutes.toString(10));
    this.save = null;
  }

  @computed
  get valid() {
    return this.name.valid && this.utcOffset.valid;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    this.utcOffset.markTouched();

    if (!this.valid)
      return;
    const model: TimeZoneUpdateModel = {
      Name: this.name.value,
      UtcOffsetMinutes: toInt(this.utcOffset.value, -14 * 60, 14 * 60)!
    };
    this.save = timeZoneLoaders.update(this.timeZone.Id, model);
  }
}
